import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCocktail: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCocktail"><Path d="M12 13.0294L2.5 3.5H21.5L12 13.0294Z" stroke="currentColor" strokeLinecap="square"/><Path d="M12 13.0293V21.4999" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 21.5H12H16.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCocktail;
